(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["doc-legend"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    const ETATS = ['live', 'todo', 'soon'];

    const compter = () => {
      for (const legende of document.querySelectorAll('[data-doc-legend]')) {
        const doc = legende.closest('[data-doc]') ?? document;
        for (const etat of ETATS) {
          const n = doc.querySelectorAll(`.doc-feature--${etat}`).length;
          for (const c of legende.querySelectorAll(`[data-doc-count="${etat}"]`)) {
            c.textContent = `${n} ${n > 1 ? 'points' : 'point'}`;
          }
        }
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', compter);
    } else {
      compter();
    }
    document.addEventListener('shopify:section:load', compter);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq"] && !Shopify.designMode) return;
  try {
    (function () {
    function cible(liste) {
      var section = liste.closest('[data-section-type]') || document;
      var sel = liste.dataset.claimsTarget || '.rich-text__body';
      var candidats = section.querySelectorAll(sel);
      for (var i = 0; i < candidats.length; i++) {
        if (!liste.contains(candidats[i])) return candidats[i];
      }
      return null;
    }

    var MOUVEMENT_REDUIT = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Reference fournie sur le ticket : Rhode empile ses contenus et les fait
       se croiser en opacite (swiper-fade), les inactifs portant inert et
       aria-hidden. Notre bascule enchainait un fondu SORTANT puis un fondu
       ENTRANT sur un seul element, ce qui n'est pas la meme chose : entre les
       deux, le bloc etait vide. On prepare donc un calque par reponse. */
    function preparerCalques(liste, cle) {
      if (cle.dataset.claimsPret) return;
      cle.dataset.claimsPret = '1';
      cle.classList.add('claims-pile');

      var reponses = liste.querySelectorAll('.accordion-item__answer');
      cle.innerHTML = '';

      for (var i = 0; i < reponses.length; i++) {
        var calque = document.createElement('div');
        calque.className = 'claims-pile__calque';
        calque.setAttribute('data-claims-calque', i);
        calque.innerHTML = reponses[i].innerHTML;
        if (i > 0) {
          calque.inert = true;
          calque.setAttribute('aria-hidden', 'true');
        } else {
          calque.setAttribute('data-active', '');
        }
        cle.appendChild(calque);
      }
    }

    /* Reference du ticket : chez Rhode le visuel de droite change aussi, sur un
       carrousel VERTICAL synchronise avec les onglets. Les images vivent sur
       les items ; on les remonte une fois dans le media de la section, puis on
       decale la piste. */
    function preparerVisuels(liste) {
      var section = liste.closest('[data-section-type]');
      if (!section) return null;
      var media = section.querySelector('.image-text__media');
      if (!media) return null;
      if (media.dataset.claimsVisuels) return media;

      var visuels = liste.querySelectorAll('.accordion-item__visuel');
      if (!visuels.length) return null;

      media.dataset.claimsVisuels = '1';
      media.classList.add('claims-visuels');

      var piste = document.createElement('div');
      piste.className = 'claims-visuels__piste';

      var origine = media.querySelector('.image-text__media-img, picture, img');
      var premier = document.createElement('div');
      premier.className = 'claims-visuels__vue';
      if (origine) premier.appendChild(origine);
      piste.appendChild(premier);

      for (var i = 0; i < visuels.length; i++) {
        var vue = document.createElement('div');
        vue.className = 'claims-visuels__vue';
        vue.innerHTML = visuels[i].innerHTML;
        piste.appendChild(vue);
      }

      media.appendChild(piste);
      return media;
    }

    function croiser(cle, index) {
      var calques = cle.querySelectorAll('[data-claims-calque]');
      for (var i = 0; i < calques.length; i++) {
        var on = i === index;
        if (on) {
          calques[i].setAttribute('data-active', '');
          calques[i].inert = false;
          calques[i].removeAttribute('aria-hidden');
        } else {
          calques[i].removeAttribute('data-active');
          calques[i].inert = true;
          calques[i].setAttribute('aria-hidden', 'true');
        }
      }
    }

    function activer(liste, item) {
      var cle = cible(liste);
      var reponse = item.querySelector('.accordion-item__answer');
      liste.querySelectorAll('[data-claims-active]').forEach(function (a) {
        a.removeAttribute('data-claims-active');
        var t = a.querySelector('[data-accordion-trigger]');
        if (t) t.setAttribute('aria-pressed', 'false');
      });
      item.setAttribute('data-claims-active', '');
      var trigger = item.querySelector('[data-accordion-trigger]');
      if (trigger) trigger.setAttribute('aria-pressed', 'true');

      var items = [].slice.call(liste.querySelectorAll('[data-accordion-item]'));
      var rang = items.indexOf(item);

      if (cle) {
        preparerCalques(liste, cle);
        croiser(cle, rang);
      }

      var media = preparerVisuels(liste);
      if (media) {
        var vues = media.querySelectorAll('.claims-visuels__vue');
        /* La premiere vue est l'image d'origine de la section : les visuels des
           items la suivent, d'ou le decalage de 1. Un item sans image retombe
           donc sur l'image de section. */
        var n = vues.length > items.length ? rang + 1 : rang;
        if (!media.querySelector('.claims-visuels__vue:nth-child(' + (n + 1) + ') img')) n = 0;
        media.style.setProperty('--claims-vue', n);
      }
    }

    function reserver(liste, cle) {
      var largeur = cle.getBoundingClientRect().width;
      if (!largeur) return;
      var banc = cle.cloneNode(false);
      banc.style.position = 'absolute';
      banc.style.visibility = 'hidden';
      banc.style.pointerEvents = 'none';
      banc.style.minHeight = '0';
      banc.style.width = largeur + 'px';
      cle.style.minHeight = '';
      cle.parentNode.appendChild(banc);
      var max = 0;
      liste.querySelectorAll('.accordion-item__answer').forEach(function (r) {
        banc.innerHTML = r.innerHTML;
        max = Math.max(max, banc.getBoundingClientRect().height);
      });
      banc.parentNode.removeChild(banc);
      cle.style.minHeight = Math.ceil(max) + 'px';
    }

    function brancher() {
      document.querySelectorAll('[data-claims-switch]').forEach(function (liste) {
        if (liste.dataset.claimsReady) return;
        var items = liste.querySelectorAll('[data-accordion-item]');
        if (!items.length) return;
        liste.dataset.claimsReady = 'true';
        liste.classList.add('is-ready');

        var POINTEUR_FIN = window.matchMedia('(hover: hover) and (pointer: fine)');

        items.forEach(function (item) {
          var trigger = item.querySelector('[data-accordion-trigger]');
          if (!trigger) return;
          trigger.removeAttribute('aria-expanded');
          trigger.setAttribute('aria-pressed', 'false');
          trigger.addEventListener('click', function () { activer(liste, item); });

          /* Le survol suffit a changer de contenu, comme sur la reference.
             Limite aux pointeurs fins pour ne pas se declencher au toucher. */
          trigger.addEventListener('pointerenter', function (e) {
            if (!POINTEUR_FIN.matches) return;
            if (e.pointerType && e.pointerType !== 'mouse') return;
            activer(liste, item);
          });
        });

        activer(liste, items[0]);

        var cle = cible(liste);
        if (cle) {
          var recalculer = function () { reserver(liste, cle); };
          recalculer();
          window.addEventListener('load', recalculer);
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(recalculer);
          }
          var minuteur;
          window.addEventListener('resize', function () {
            window.clearTimeout(minuteur);
            minuteur = window.setTimeout(recalculer, 150);
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', brancher);
    } else {
      brancher();
    }
    document.addEventListener('shopify:section:load', brancher);
  })();

    function boutonDe(liste) {
      var portee = liste.closest('.content-group') || liste.closest('section');
      if (!portee) return null;
      var candidats = portee.querySelectorAll('.button-block__el');
      for (var i = 0; i < candidats.length; i++) {
        if (!candidats[i].getAttribute('href')) return candidats[i];
      }
      return null;
    }

    function limiter() {
      var listes = document.querySelectorAll('[data-faq-visible]');
      for (var i = 0; i < listes.length; i++) {
        var liste = listes[i];
        var n = parseInt(liste.getAttribute('data-faq-visible'), 10);
        if (!n) continue;
        var enfants = liste.children;
        for (var j = n; j < enfants.length; j++) {
          enfants[j].hidden = true;
          enfants[j].setAttribute('data-faq-extra', '');
          /* Un item replie ne doit pas rester ouvert : sinon il reapparait
             deplie au depli suivant, et la liste perd sa reponse ouverte. */
          enfants[j].querySelectorAll('[data-accordion-item][data-open]').forEach(function (item) {
            item.removeAttribute('data-open');
            var t = item.querySelector('[data-accordion-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }
        liste.removeAttribute('data-faq-open');

        /* L'etat doit etre annonce des le chargement, pas seulement apres le
           premier clic, et il doit rester coherent apres un rechargement de
           section dans l'editeur. */
        var bouton = boutonDe(liste);
        if (bouton && enfants.length > n) {
          bouton.setAttribute('aria-expanded', 'false');
          if (bouton.dataset.faqMore) bouton.textContent = bouton.dataset.faqMore;
        }
      }
    }

    /* Le bouton BASCULE : « voir plus » déplie, « voir moins » replie. Il ne
       disparaît plus une fois déplié — sans retour en arrière, la liste longue
       restait ouverte pour toute la visite. */
    document.addEventListener('click', function (event) {
      var bouton = event.target.closest('.button-block__el');
      if (!bouton || bouton.getAttribute('href')) return;
      var portee = bouton.closest('.content-group') || bouton.closest('section') || document;
      var liste = portee.querySelector('[data-faq-visible]');
      if (!liste) return;

      var n = parseInt(liste.getAttribute('data-faq-visible'), 10);
      if (!n) return;
      var enfants = liste.children;
      if (enfants.length <= n) return;

      event.preventDefault();
      var deplie = liste.hasAttribute('data-faq-open');

      for (var j = n; j < enfants.length; j++) {
        enfants[j].hidden = deplie;
        if (deplie) {
          enfants[j].setAttribute('data-faq-extra', '');
          /* Un item qu'on masque doit etre referme, sinon il reapparait
             deplie au depli suivant et la liste perd sa reponse ouverte. */
          enfants[j].querySelectorAll('[data-accordion-item][data-open]').forEach(function (item) {
            item.removeAttribute('data-open');
            var t = item.querySelector('[data-accordion-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        } else {
          enfants[j].removeAttribute('data-faq-extra');
        }
      }

      /* Le libellé d'origine est relevé au premier clic : il vient du réglage
         du block bouton, le JS n'a pas à le connaître. */
      if (!bouton.dataset.faqMore) bouton.dataset.faqMore = bouton.textContent.trim();
      var moins = liste.getAttribute('data-faq-less') || 'Voir moins';
      bouton.textContent = deplie ? bouton.dataset.faqMore : moins;

      if (deplie) liste.removeAttribute('data-faq-open');
      else liste.setAttribute('data-faq-open', '');
      bouton.setAttribute('aria-expanded', deplie ? 'false' : 'true');

      /* Au repli, le focus pouvait se trouver sur un item qui vient d'etre
         masque : il retombait alors sur le body, en haut du document. */
      if (deplie && !portee.contains(document.activeElement)) bouton.focus();
      if (deplie && document.activeElement && document.activeElement.closest &&
          document.activeElement.closest('[data-faq-extra]')) bouton.focus();

      /* En repliant depuis le bas de la liste, la page remonte sous les pieds
         de l'utilisateur : on ramène la liste dans l'écran si son haut est
         passé au-dessus. */
      if (deplie && liste.getBoundingClientRect().top < 0) {
        liste.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', limiter);
    } else {
      limiter();
    }
    document.addEventListener('shopify:section:load', limiter);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["results-media"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    const init = (root) => {
      if (root.dataset.riReady || typeof Swiper === 'undefined') return;
      const el = root.matches('[data-ri-swiper]') ? root : root.querySelector('[data-ri-swiper]');
      if (!el) return;
      root.dataset.riReady = 'true';

      const media = el.closest('.results__media') ?? el;
      const prev = media.querySelector('[data-ri-prev]');
      const next = media.querySelector('[data-ri-next]');

      const piste = el.querySelector('.swiper-wrapper');
      if (piste) {
        for (const enfant of piste.children) enfant.classList.add('swiper-slide');
      }

      const sync = (sw) => {
        const instance = sw ?? el.swiper;
        if (!instance) return;
        if (prev) prev.disabled = instance.isBeginning;
        if (next) next.disabled = instance.isEnd;
      };

      const swiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 18,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: { 0: { spaceBetween: 6 }, 990: { spaceBetween: 18 } },
        on: { init: sync, slideChange: sync, resize: sync },
      });

      prev?.addEventListener('click', () => swiper.slidePrev());
      next?.addEventListener('click', () => swiper.slideNext());
      sync(swiper);
    };

    const boot = () => {
      for (const el of document.querySelectorAll('[data-ri-swiper]')) init(el);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    window.addEventListener('load', boot);
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["timeline"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    const REPERE = 0.66;

    const avancement = (rail) => {
      const r = rail.getBoundingClientRect();
      if (!r.height) return 0;
      const ligne = window.innerHeight * REPERE;
      return Math.min(Math.max(ligne - r.top, 0), r.height);
    };

    const peindre = (rail) => {
      const px = avancement(rail);
      rail.style.setProperty('--timeline-progress', `${px}px`);
      const haut = rail.getBoundingClientRect().top;
      for (const etape of rail.children) {
        const y = etape.getBoundingClientRect().top - haut + 8;
        etape.classList.toggle('is-reached', px >= y);
      }
    };

    const brancher = () => {
      for (const rail of document.querySelectorAll('[data-timeline]')) {
        if (rail.dataset.timelineReady || rail.children.length < 2) continue;
        rail.dataset.timelineReady = 'true';
        rail.classList.add('timeline--progressive');
        peindre(rail);
        window.addEventListener('scroll', () => peindre(rail), { passive: true });
        window.addEventListener('resize', () => peindre(rail));
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', brancher);
    } else {
      brancher();
    }
    document.addEventListener('shopify:section:load', brancher);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function suivre(event) {
      if (REDUCED.matches) return;
      var media = event.target.closest ? event.target.closest('[data-rc-media]') : null;
      if (!media || media.classList.contains('is-playing')) return;
      var play = media.querySelector('[data-rc-play]');
      if (!play) return;
      var box = media.getBoundingClientRect();
      var bouton = play.getBoundingClientRect();
      var maxX = Math.max(0, (box.width - bouton.width) / 2);
      var maxY = Math.max(0, (box.height - bouton.height) / 2);
      var dx = event.clientX - (box.left + box.width / 2);
      var dy = event.clientY - (box.top + box.height / 2);
      play.style.setProperty('--video-carousel-x', Math.max(-maxX, Math.min(maxX, dx)) + 'px');
      play.style.setProperty('--video-carousel-y', Math.max(-maxY, Math.min(maxY, dy)) + 'px');
    }

    document.addEventListener('pointermove', suivre);

    document.addEventListener('pointerout', function (event) {
      var media = event.target.closest ? event.target.closest('[data-rc-media]') : null;
      if (!media) return;
      if (event.relatedTarget && media.contains(event.relatedTarget)) return;
      var play = media.querySelector('[data-rc-play]');
      if (!play) return;
      play.style.setProperty('--video-carousel-x', '0px');
      play.style.setProperty('--video-carousel-y', '0px');
    });

    var zoom = null;
    var declencheur = null;

    function construire() {
      if (zoom) return zoom;
      zoom = document.createElement('div');
      zoom.className = 'video-zoom';
      zoom.setAttribute('role', 'dialog');
      zoom.setAttribute('aria-modal', 'true');
      zoom.dataset.titre = document.documentElement.lang === 'en' ? 'Video' : 'Vidéo';
      zoom.dataset.fermer = document.documentElement.lang === 'en' ? 'Close' : 'Fermer';
      zoom.hidden = true;
      zoom.setAttribute('aria-label', zoom.dataset.titre || 'Video');
      zoom.innerHTML =
        '<div class="video-zoom__fond" data-zoom-fond></div>' +
        '<div class="video-zoom__scene"><div class="video-zoom__cadre" data-zoom-cadre></div>' +
        '<button type="button" class="video-zoom__fermer" data-zoom-fermer></button></div>';
      zoom.querySelector('[data-zoom-fermer]').setAttribute('aria-label', zoom.dataset.fermer || 'Fermer');
      document.body.appendChild(zoom);

      zoom.addEventListener('click', function (e) {
        if (e.target.closest('[data-zoom-fermer]') || e.target.closest('[data-zoom-fond]')) fermer();
      });

      /* Piege de focus : tant que la couche est ouverte, la tabulation ne doit
         pas partir dans la page cachee derriere. */
      zoom.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusables = zoom.querySelectorAll(
          'button, [href], video[controls], iframe, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        var premier = focusables[0];
        var dernier = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === premier) {
          e.preventDefault();
          dernier.focus();
        } else if (!e.shiftKey && document.activeElement === dernier) {
          e.preventDefault();
          premier.focus();
        }
      });

      return zoom;
    }

    var minuteurFermeture = null;

    function fermer() {
      if (!zoom || zoom.hidden) return;
      zoom.classList.remove('is-open');
      var cadre = zoom.querySelector('[data-zoom-cadre]');
      var v = cadre.querySelector('video');
      if (v) v.pause();

      if (minuteurFermeture) window.clearTimeout(minuteurFermeture);
      minuteurFermeture = window.setTimeout(function () {
        minuteurFermeture = null;
        cadre.innerHTML = '';
        zoom.hidden = true;
      }, 400);

      document.documentElement.style.overflow = '';
      if (declencheur) declencheur.focus();
      declencheur = null;
    }

    function ouvrir(template, bouton) {
      var boite = construire();
      if (minuteurFermeture) {
        window.clearTimeout(minuteurFermeture);
        minuteurFermeture = null;
      }
      var cadre = boite.querySelector('[data-zoom-cadre]');
      var scene = boite.querySelector('.video-zoom__scene');
      /* Repartir du format par defaut : sans ce retrait, une video gardait le
         format de la precedente (le style inline bat la media query). */
      if (scene) scene.style.removeProperty('--video-ratio');
      /* Un embed n'expose pas son format : le gabarit porte celui de sa source
         (paysage). Sans ca, un YouTube heritait du 9/16 mobile de la feuille. */
      if (scene && template.dataset.ratio) {
        scene.style.setProperty('--video-ratio', template.dataset.ratio);
      }
      cadre.innerHTML = '';
      cadre.appendChild(template.content.cloneNode(true));
      boite.hidden = false;
      declencheur = bouton;
      document.documentElement.style.overflow = 'hidden';

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { boite.classList.add('is-open'); });
      });

      var fermeture = boite.querySelector('[data-zoom-fermer]');
      if (fermeture) fermeture.focus();

      if (!boite.dataset.gardeFocus) {
        boite.dataset.gardeFocus = '1';
        document.addEventListener('focusin', function (e) {
          if (boite.hidden || boite.contains(e.target)) return;
          var f = boite.querySelector('[data-zoom-fermer]');
          if (f) f.focus();
        });
      }

      var video = cadre.querySelector('video');
      if (video) {
        /* Le cadre epouse le format reel de la video : sans ca, une video
           portrait dans le cadre 16/9 du desktop sortait avec 376px de bandes
           noires de chaque cote. Les embeds n'exposent pas leur format : ils
           gardent le repli de la feuille. */
        var ajusterFormat = function () {
          if (!scene || !video.videoWidth || !video.videoHeight) return;
          scene.style.setProperty('--video-ratio', video.videoWidth / video.videoHeight);
        };
        ajusterFormat();
        video.addEventListener('loadedmetadata', ajusterFormat, { once: true });

        var lancer = function () {
          var lecture = video.play();
          if (lecture && lecture.catch) lecture.catch(function () {});
        };
        lancer();
        video.addEventListener('canplay', lancer, { once: true });
        video.addEventListener('loadeddata', lancer, { once: true });
      }
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-rc-play]');
      if (!button) return;
      var media = button.closest('[data-rc-media]');
      var template = media && media.querySelector('[data-rc-video]');
      if (!template) return;
      ouvrir(template, button);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') fermer();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
